import React from 'react';

import FacebookButton from './Buttons/FacebookButton';
import GoogleButton from './Buttons/GoogleButton';
import { ProviderLoginParams } from './Types';
import * as styles from './styles.module.css';

const ProviderLogin = ({ returnUrl }: ProviderLoginParams): JSX.Element => {
  return (
    <div className={styles.buttonContainer}>
      {FacebookButton({ returnUrl })}
      {GoogleButton({ returnUrl })}
    </div>
  );
};

export default ProviderLogin;
